/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LDAPServer,
    LDAPServerFromJSON,
    LDAPServerFromJSONTyped,
    LDAPServerToJSON,
} from './';

/**
 * 
 * @export
 * @interface ElementsUserProfile
 */
export interface ElementsUserProfile {
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfile
     */
    avatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfile
     */
    defaultPage?: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfile
     */
    fullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfile
     */
    language?: ElementsUserProfileLanguageEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserProfile
     */
    fmBookmarks?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ElementsUserProfile
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfile
     */
    readonly username: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfile
     */
    readonly unixUsername?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfile
     */
    readonly displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ElementsUserProfile
     */
    readonly email?: string | null;
    /**
     * 
     * @type {LDAPServer}
     * @memberof ElementsUserProfile
     */
    ldap: LDAPServer;
    /**
     * 
     * @type {Array<string>}
     * @memberof ElementsUserProfile
     */
    readonly effectivePermissions: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserProfile
     */
    readonly hasPassword: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ElementsUserProfile
     */
    readonly allowChangingPassword: boolean;
}

/**
* @export
* @enum {string}
*/
export enum ElementsUserProfileLanguageEnum {
    En = 'en',
    Fr = 'fr',
    De = 'de',
    Ru = 'ru'
}

export function ElementsUserProfileFromJSON(json: any): ElementsUserProfile {
    return ElementsUserProfileFromJSONTyped(json, false);
}

export function ElementsUserProfileFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElementsUserProfile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'avatar': !exists(json, 'avatar') ? undefined : json['avatar'],
        'defaultPage': !exists(json, 'default_page') ? undefined : json['default_page'],
        'fullName': !exists(json, 'full_name') ? undefined : json['full_name'],
        'language': !exists(json, 'language') ? undefined : json['language'],
        'fmBookmarks': !exists(json, 'fm_bookmarks') ? undefined : json['fm_bookmarks'],
        'id': json['id'],
        'username': json['username'],
        'unixUsername': !exists(json, 'unix_username') ? undefined : json['unix_username'],
        'displayName': json['display_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'ldap': LDAPServerFromJSON(json['ldap']),
        'effectivePermissions': json['effective_permissions'],
        'hasPassword': json['has_password'],
        'allowChangingPassword': json['allow_changing_password'],
    };
}

export function ElementsUserProfileToJSON(value?: ElementsUserProfile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'avatar': value.avatar,
        'default_page': value.defaultPage,
        'full_name': value.fullName,
        'language': value.language,
        'fm_bookmarks': value.fmBookmarks,
        'id': value.id,
        'ldap': LDAPServerToJSON(value.ldap),
    };
}


